// Copied from advisor-3.0/src/components/HelpCenter/HelpCenter.js
import { useState } from 'react';
import { Box, Typography } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import GroupIcon from '@mui/icons-material/Group';
import SupportModal from 'src/components/Layout/SupportModal';
import './HelpCenter.scss';

interface HelpCenterProps {
  expanded: boolean;
}

const HelpCenter = ({ expanded }: HelpCenterProps) => {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <Box
      sx={(theme) => ({ color: theme.palette.primary.contrastText })}
      className={`${expanded ? '' : 'd-flex align-items-center flex-column'} help-center`}
    >
      {expanded ? (
        <Box
          sx={(theme) => ({ mt: theme.spacing(1), px: theme.spacing(2), py: theme.spacing(1) })}
          className="team-container"
          onClick={() => setModalOpen(true)}
        >
          <Typography variant="h6" className="contact-text">Contact Covr</Typography>
          <ArrowForwardIosIcon className="ml-auto" fontSize="small" />
        </Box>
      ) : (
        <Box sx={(theme) => ({ mb: theme.spacing(1) })} onClick={() => setModalOpen(true)}>
          <GroupIcon />
        </Box>
      )}
      <SupportModal open={modalOpen} handleClose={() => setModalOpen(false)} />
    </Box>
  );
};

export default HelpCenter;
